import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "reached-limit-actions-header"
}

import VIconButton from './VIconButton.vue';
import CloseIcon from './icons/navigation/CloseIcon.vue';
import { useUiStore } from '@/stores/ui';
import { useFacebookStore } from '@/stores/facebook';


export default /*#__PURE__*/_defineComponent({
  __name: 'FacebookAlertHeader',
  setup(__props) {


const uiStore = useUiStore()
const facebookStore = useFacebookStore()

const close = () => {
  uiStore.showFacebookAlert = false
}

const tryAgain = () => {
  facebookStore.connectFacebook()
}


return (_ctx: any,_cache: any) => {
  return (_unref(uiStore).showFacebookAlert)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createTextVNode(" Required permissions missing! "),
        _createElementVNode("a", { onClick: tryAgain }, "Try again"),
        _createVNode(VIconButton, { onClick: close }, {
          default: _withCtx(() => [
            _createVNode(CloseIcon)
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})